/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __assign } from "tslib";
import { ParamDefinition as PD } from '../../mol-util/param-definition';
import { BoundingSphereHelper, DebugHelperParams } from './bounding-sphere-helper';
import { CameraHelper, CameraHelperParams } from './camera-helper';
import { HandleHelper, HandleHelperParams } from './handle-helper';
export var HelperParams = {
  debug: PD.Group(DebugHelperParams),
  camera: PD.Group({
    helper: PD.Group(CameraHelperParams)
  }),
  handle: PD.Group(HandleHelperParams)
};
export var DefaultHelperProps = PD.getDefaultValues(HelperParams);

var Helper =
/** @class */
function () {
  function Helper(webgl, scene, props) {
    if (props === void 0) {
      props = {};
    }

    var p = __assign(__assign({}, DefaultHelperProps), props);

    this.debug = new BoundingSphereHelper(webgl, scene, p.debug);
    this.camera = new CameraHelper(webgl, p.camera.helper);
    this.handle = new HandleHelper(webgl, p.handle);
  }

  return Helper;
}();

export { Helper };